import {MainRequest} from './common';
import lodash from 'lodash-es';

export interface RoleListItem {
    code: string;
    createUser: string;
    id: string;
    roleName: string;
    status: string;
    defaultFlag: BooleanValue; // 内置角色
}

/**
 * 取得角色列表
 */
export function getRoleList() {
    return MainRequest.post<SuccessData<RoleListItem[]>>('/role/list').then(
        res => res.data.data,
    );
}

interface FunctionListTree {
    id: string;
    name: string;
    code: string;
    children?: FunctionListTree[];
}

/**
 * 获取权限元数据
 */
export async function getRoleFunctionList() {
    const data = await MainRequest.post<SuccessData<FunctionListTree[]>>(
        '/function/getFunctionTree',
    ).then(res => res.data.data);

    function getSubTree(data: FunctionListTree[]): string[] {
        const code = data.map(item => item.code);

        const subCode = data.reduce<string[]>((memo, item) => {
            return [...memo, ...getSubTree(item.children || [])];
        }, []);

        return [...code, ...subCode];
    }

    return getSubTree(data);
}

/**
 * 用户修改密码
 * @param data
 */
export function changePwd(data: {password: string; oldPassword: string}) {
    data = lodash.cloneDeep(data);
    return MainRequest.post('/user/changePwd', data);
}
